import { css } from 'styled-components';

/**
 * Styles used to compose textarea and input.
 */
// eslint-disable-next-line import/prefer-default-export
export const inputStyles = css`
  display: block;
  min-width: 0;
  width: 100%;
  height: 19px;
  min-height: auto;
  margin: 0;
  padding: 6px 0 7px !important;
  font: inherit;
  font-weight: normal;
  color: currentColor;
  background: none;
  border: 0 !important;
  box-sizing: content-box;
  box-shadow: none;
  transition: none;
  -webkit-tap-highlight-color: transparent;
  outline: none;

  &::placeholder {
    font-style: italic;
    color: #9a9a9a;
    opacity: 1;
  }

  &:focus {
    border: none;
    background-color: transparent;
    box-shadow: none;
    transition: none;
    outline: none;
  }

  &:valid,
  &:invalid {
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.5;
  }

  &::-webkit-search-decoration {
    -webkit-appearance: none;
  }
`;
